(function () {
    //Note, this needs to match the lable of the Time field, so that the script can identify the relevant field on the form. 
    let time_field_label = "Time";

    function getTimeSelectElement(form) {
        let labels = Array.from(form.querySelectorAll('label'));

        let matchingLabel = labels.find(function (label) {
            let cleanText = label.textContent
                .replace(/[\s\u00A0]+/g, ' ')
                .replace(/\*/g, '')
                .trim()
                .toLowerCase();

            return cleanText === time_field_label.toLowerCase();
        });

        if (matchingLabel) {
            let forId = matchingLabel.getAttribute('for');
            if (forId) {
                let el = document.getElementById(forId);
                if (el) return el;
            }
            let container = matchingLabel.closest('.umbraco-forms-field, .umbraco-forms-field-wrapper') || matchingLabel.parentElement;
            if (container) {
                var selectInContainer = container.querySelector('select');
                if (selectInContainer) return selectInContainer;
            }
        }

        return form.querySelector('select');
    }

    function filterTimeSlots(selectedDate, dateInput) {
        if (!selectedDate) return;

        let form = dateInput.closest('form') || document;
        let timeSelect = getTimeSelectElement(form);
        if (!timeSelect) return;

        let choicesWrapper = timeSelect.closest('.choices');
        if (!choicesWrapper) return;

        let now = new Date();
        let isToday = selectedDate.toDateString() === now.toDateString();

        let currentMinutes = (now.getHours() * 60) + now.getMinutes();
        let hide9am = isToday && (currentMinutes >= 9 * 60);   // Past 09:00 AM
        let hide1pm = isToday && (currentMinutes >= 13 * 60);  // Past 01:00 PM

        function shouldHideSlot(val) {
            val = (val || '').toLowerCase().trim();
            if (val.includes('9am')) return hide9am;
            if (val.includes('1pm')) return hide1pm;
            return false;
        }

        Array.from(timeSelect.options).forEach(function (option) {
            let hide = shouldHideSlot(option.value || option.textContent);
            option.disabled = hide;
            option.hidden = hide;
        });

        let dropdownList = choicesWrapper.querySelector('.choices__list.dropdown') || choicesWrapper;
        let items = Array.from(dropdownList.querySelectorAll('[data-value]'));

        items.forEach(function (item) {
            let hide = shouldHideSlot(item.getAttribute('data-value') || item.textContent);

            if (hide) {
                item.style.setProperty('display', 'none', 'important');
            } else {
                item.style.removeProperty('display');
            }
        });

        let currentSelectedOption = timeSelect.options[timeSelect.selectedIndex];
        let isCurrentValid = currentSelectedOption &&
            currentSelectedOption.value &&
            !currentSelectedOption.disabled &&
            !currentSelectedOption.hidden;

        let targetOption = null;

        if (isCurrentValid) {
            targetOption = currentSelectedOption;
        } else {
            let validOptions = Array.from(timeSelect.options).filter(function (opt) {
                return opt.value && !opt.disabled && !opt.hidden;
            });
            targetOption = validOptions.length > 0 ? validOptions[0] : null;
        }

        Array.from(timeSelect.options).forEach(function (opt) {
            if (targetOption && opt === targetOption) {
                opt.selected = true;
                opt.setAttribute('selected', 'selected');
            } else {
                opt.selected = false;
                opt.removeAttribute('selected');
            }
        });

        if (targetOption) {
            timeSelect.value = targetOption.value;
        } else {
            timeSelect.value = "";
        }

        let headerContainer = choicesWrapper.querySelector('.choices__list.h-full') ||
            choicesWrapper.querySelector('.choices__list:not(.dropdown)');

        if (headerContainer) {
            let textDiv = headerContainer.querySelector('div') || headerContainer;
            if (targetOption) {
                textDiv.textContent = targetOption.textContent.trim();
                textDiv.classList.remove('opacity-50');
            } else {
                textDiv.textContent = 'No slots available today';
                textDiv.classList.add('opacity-50');
            }
        }

        if (!isCurrentValid && targetOption) {
            let targetVal = targetOption.value.toLowerCase().trim();
            let matchingChoiceItem = items.find(function (item) {
                let val = (item.getAttribute('data-value') || item.textContent || '').toLowerCase().trim();
                return val === targetVal;
            });

            if (matchingChoiceItem) {
                matchingChoiceItem.click();
            }
        }

        timeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function isWeekend(date) {
        return date.getDay() === 0 || date.getDay() === 6;
    }

    function toDateKey(date) {
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, '0');
        let day = String(date.getDate()).padStart(2, '0');
        return year + '-' + month + '-' + day;
    }

    function isDateAvailable(date, blackoutSet) {
        return !isWeekend(date) && !blackoutSet.has(toDateKey(date));
    }

    // Walks forward day-by-day from fromDate (bounded by minDate/maxDate) to find
    // the next date that isn't a weekend or blackout date.
    function findNextAvailableDate(fromDate, blackoutSet, minDate, maxDate) {
        let candidate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
        let minD = minDate ? new Date(minDate) : null;
        let maxD = maxDate ? new Date(maxDate) : null;

        if (minD && candidate < minD) {
            candidate = minD;
        }

        for (let i = 0; i < 366; i++) {
            if (maxD && candidate > maxD) return null;

            if (isDateAvailable(candidate, blackoutSet)) {
                return candidate;
            }

            candidate.setDate(candidate.getDate() + 1);
        }

        return null;
    }

    async function fetchBlackoutDates(apiUrl) {
        if (!apiUrl) return [];

        try {
            let response = await fetch(apiUrl, {
                method: 'GET',
                headers: { 'Accept': 'application/json' }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok: ' + response.statusText);
            }

            let data = await response.json();

            if (Array.isArray(data)) return data;

            if (typeof data === 'string') {
                let parsed = JSON.parse(data);
                return Array.isArray(parsed) ? parsed : [];
            }

            return [];
        } catch (error) {
            console.error('Error fetching blackout dates:', error);
            return [];
        }
    }

    async function initFlatpickrForField(input) {
        if (typeof flatpickr === 'undefined') {
            setTimeout(function () { initFlatpickrForField(input); }, 100);
            return;
        }

        if (input._flatpickr) {
            input._flatpickr.destroy();
        }

        let hiddenFieldId = input.getAttribute("data-hidden-id");
        let apiUrl = input.getAttribute("data-api-url");
        let minDate = input.getAttribute("data-min-date") || null;
        let maxDate = input.getAttribute("data-max-date") || null;

        let hiddenInput = hiddenFieldId ? document.getElementById(hiddenFieldId) : null;

        let blackoutDates = await fetchBlackoutDates(apiUrl);
        let blackoutSet = new Set(blackoutDates);

        flatpickr(input, {
            minDate: minDate,
            maxDate: maxDate,
            disable: [
                ...blackoutDates,
                function (date) {
                    return isWeekend(date);
                }
            ],
            onChange: function (selectedDates, dateStr) {
                if (hiddenInput) {
                    hiddenInput.value = dateStr;
                }

                if (selectedDates.length > 0) {
                    requestAnimationFrame(function () {
                        requestAnimationFrame(function () {
                            filterTimeSlots(selectedDates[0], input);
                        });
                    });
                }
            },
            onReady: function (selectedDates, dateStr, instance) {
                let referenceDate = selectedDates.length > 0 ? selectedDates[0] : new Date();
                referenceDate = new Date(referenceDate.getFullYear(), referenceDate.getMonth(), referenceDate.getDate());

                if (!isDateAvailable(referenceDate, blackoutSet)) {
                    let nextAvailable = findNextAvailableDate(referenceDate, blackoutSet, minDate, maxDate);
                    if (nextAvailable) {
                        instance.setDate(nextAvailable, true);
                    }
                }
            }
        });
    }

    function initAllBlackoutFields() {
        let elements = document.querySelectorAll('.js-blackout-datepicker');
        elements.forEach(function (input) {
            initFlatpickrForField(input);
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initAllBlackoutFields);
    } else {
        initAllBlackoutFields();
    }
})();